<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title>Ofertas de ingresso</v-card-title>
      <v-card-text v-if="!groupSelected">Selecione um grupo</v-card-text>
      <template v-else>
        <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="start">
          <v-tab value="cadastro">Cadastro</v-tab>
          <v-tab value="publicacao">Publicação no site</v-tab>
          <v-tab value="emitidos">Ingressos emitidos</v-tab>
        </v-tabs>
        <v-window v-model="tab">
          <v-window-item value="cadastro">
            <v-row>
              <v-col cols="12">
                <p class="text-caption px-4 pt-4 mb-0">
                  O site ggrupos.com.br só publica após moderação no WordPress.
                </p>
                <v-form @submit.prevent="submitOfferSearch">
                  <v-card color="grey-lighten-2" variant="flat" class="ma-3">
                    <v-card-title>
                      Filtro de pesquisa
                      <v-btn
                             color="primary"
                             class="float-right"
                             density="compact"
                             @click="openCreate">
                        <v-icon class="mr-2">mdi-plus</v-icon>
                        Nova oferta
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                                        v-model="offerFilters.searchText"
                                        label="Título"
                                        clearable
                                        density="compact"
                                        hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <v-select
                                    :items="[25, 50, 100, 200]"
                                    v-model="offerFilters.itemsPerPage"
                                    label="Resultados por página"
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-btn color="warning" @click="clearOfferFilters">
                          <v-icon class="mr-2">mdi-broom</v-icon>
                          Limpar pesquisa
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" :loading="loadingOffers">
                          <v-icon class="mr-2">mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-col>
              <v-col cols="12">
                <v-data-table
                              :headers="cadastroHeaders"
                              :items="offers"
                              :loading="loadingOffers"
                              :items-per-page="offerFilters.itemsPerPage"
                              return-object
                              class="elevation-1"
                              hide-default-footer>
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                                    :disabled="loadingOffers"
                                    v-model="offerPage"
                                    :length="offerMaxPage"></v-pagination>
                    </div>
                  </template>
                  <template v-slot:item.site_status="{ value }">
                    <span>{{ siteStatusLabel(value) }}</span>
                  </template>
                  <template v-slot:item.lots_count="{ item }">
                    <span>{{ lotsCount(item) }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                           size="small"
                           variant="text"
                           color="primary"
                           @click="editObject(item)">
                      Editar
                    </v-btn>
                    <v-btn
                           size="small"
                           variant="text"
                           color="primary"
                           :loading="mutatingId === item.id"
                           @click="pushOffer(item)">
                      Enviar ao site
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item value="publicacao">
            <v-row>
              <v-col cols="12">
                <v-form @submit.prevent="submitOfferSearch">
                  <v-card color="grey-lighten-2" variant="flat" class="ma-3">
                    <v-card-title>Filtro de publicação</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                                    v-model="offerFilters.site_status"
                                    :items="publishStatusItems"
                                    item-title="title"
                                    item-value="value"
                                    label="Status"
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <v-select
                                    :items="[25, 50, 100, 200]"
                                    v-model="offerFilters.itemsPerPage"
                                    label="Resultados por página"
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" :loading="loadingOffers">
                          <v-icon class="mr-2">mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-col>
              <v-col cols="12">
                <v-data-table
                              :headers="publishHeaders"
                              :items="offers"
                              :loading="loadingOffers"
                              :items-per-page="offerFilters.itemsPerPage"
                              return-object
                              class="elevation-1"
                              hide-default-footer>
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                                    :disabled="loadingOffers"
                                    v-model="offerPage"
                                    :length="offerMaxPage"></v-pagination>
                    </div>
                  </template>
                  <template v-slot:item.starts_at="{ value }">
                    <span>{{ formatDateTime(value) }}</span>
                  </template>
                  <template v-slot:item.lots_count="{ item }">
                    <span>{{ lotsCount(item) }}</span>
                  </template>
                  <template v-slot:item.site_status="{ value }">
                    <span>{{ siteStatusLabel(value) }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                           size="small"
                           variant="text"
                           color="primary"
                           :loading="mutatingId === item.id"
                           @click="pushOffer(item)">
                      Enviar
                    </v-btn>
                    <v-btn
                           size="small"
                           variant="text"
                           color="warning"
                           :loading="mutatingId === item.id"
                           @click="setOfferStatus(item, 'paused')">
                      Pausar
                    </v-btn>
                    <v-btn
                           size="small"
                           variant="text"
                           color="success"
                           :loading="mutatingId === item.id"
                           @click="setOfferStatus(item, 'published')">
                      Marcar publicado
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item value="emitidos">
            <v-row>
              <v-col cols="12">
                <v-form @submit.prevent="submitTicketSearch">
                  <v-card color="grey-lighten-2" variant="flat" class="ma-3">
                    <v-card-title>Filtro de ingressos emitidos</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-select
                                    v-model="ticketFilters.event_id"
                                    :items="eventFilterItems"
                                    item-title="title"
                                    item-value="value"
                                    label="Evento"
                                    clearable
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                                        v-model="ticketFilters.code"
                                        label="Código"
                                        clearable
                                        density="compact"
                                        hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select
                                    v-model="ticketFilters.status"
                                    :items="ticketStatusItems"
                                    item-title="title"
                                    item-value="value"
                                    label="Status"
                                    clearable
                                    density="compact"
                                    hide-details></v-select>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-btn color="warning" @click="clearTicketFilters">
                          <v-icon class="mr-2">mdi-broom</v-icon>
                          Limpar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" :loading="loadingTickets">
                          <v-icon class="mr-2">mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-col>
              <v-col cols="12">
                <v-data-table
                              :headers="ticketHeaders"
                              :items="tickets"
                              :loading="loadingTickets"
                              :items-per-page="ticketFilters.itemsPerPage"
                              return-object
                              class="elevation-1"
                              hide-default-footer>
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                                    :disabled="loadingTickets"
                                    v-model="ticketPage"
                                    :length="ticketMaxPage"></v-pagination>
                    </div>
                  </template>
                  <template v-slot:item.event_title="{ item }">
                    <span>{{ ticketEventTitle(item) }}</span>
                  </template>
                  <template v-slot:item.status="{ value }">
                    <span>{{ ticketStatusLabel(value) }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                           v-if="item.status === 'valid'"
                           size="small"
                           variant="text"
                           color="success"
                           :loading="mutatingCode === item.code"
                           @click="checkIn(item)">
                      Check-in
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </template>
    </v-card>

    <v-dialog v-model="dialogForm" max-width="900" scrollable>
      <v-card>
        <v-toolbar color="primary" :title="form.id ? 'Editar oferta' : 'Nova oferta'">
          <v-btn color="black" @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <AutocompleteSelectEvent
                                   :user="user"
                                   label="Evento"
                                   v-model="form.event"
                                   return-object
                                   :selected-id="form.event_id || undefined"
                                   class="mb-2" />
          <v-text-field
                        v-model="form.title"
                        label="Título"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-textarea
                      v-model="form.summary"
                      label="Resumo"
                      density="compact"
                      rows="2"
                      class="mb-2"></v-textarea>
          <v-text-field
                        v-model="form.location"
                        label="Local"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-text-field
                        v-model="form.address"
                        label="Endereço"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-text-field
                        v-model="form.starts_at"
                        type="datetime-local"
                        label="Início"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-text-field
                        v-model="form.ends_at"
                        type="datetime-local"
                        label="Fim"
                        density="compact"
                        class="mb-2"></v-text-field>
          <v-text-field
                        v-model="form.image_url"
                        label="Imagem (URL)"
                        density="compact"
                        class="mb-4"></v-text-field>
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Lotes</span>
            <v-spacer></v-spacer>
            <v-btn size="small" color="primary" variant="tonal" @click="addLot">
              <v-icon class="mr-1">mdi-plus</v-icon>
              Adicionar lote
            </v-btn>
          </div>
          <div v-for="(lot, ix) in form.lots" :key="ix" class="mb-3 pa-2 bg-grey-lighten-3 rounded">
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                              v-model="lot.name"
                              label="Nome"
                              density="compact"
                              hide-details></v-text-field>
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field
                              v-model.number="lot.price"
                              type="number"
                              min="0"
                              step="0.01"
                              label="Preço"
                              density="compact"
                              hide-details></v-text-field>
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field
                              v-model.number="lot.available_qty"
                              type="number"
                              min="0"
                              label="Quantidade"
                              density="compact"
                              hide-details></v-text-field>
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field
                              v-model.number="lot.max_per_order"
                              type="number"
                              min="1"
                              label="Máx. por pedido"
                              density="compact"
                              hide-details></v-text-field>
              </v-col>
              <v-col cols="5" md="1">
                <v-text-field
                              v-model.number="lot.max_scans"
                              type="number"
                              min="1"
                              label="Scans"
                              density="compact"
                              hide-details></v-text-field>
              </v-col>
              <v-col cols="1" class="d-flex align-center">
                <v-btn icon variant="text" color="error" @click="removeLot(ix)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn
                 color="success"
                 :loading="saving"
                 :disabled="saving"
                 @click="submitForm">
            <v-icon class="mr-2">mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import AutocompleteSelectEvent from '../components/AutocompleteSelectEvent.vue'
import api from '@/services'
import { TICKET_OFFER_STATUSES } from '@/services/ticketOffer'
import { normalizeListPayload } from '@/utils/listPayload'

const TICKET_STATUS_LABELS = {
  valid: 'Válido',
  used: 'Utilizado',
  voided: 'Anulado',
}

function emptyLot() {
  return {
    name: '',
    price: 0,
    available_qty: 0,
    max_per_order: 10,
    max_scans: 1,
  }
}

function eventFromOffer(item) {
  const id = item?.event_id || item?.event?.id || null
  if (!id) return null
  return {
    id,
    name: item.event_name || item.event?.name || item.title || `Evento #${id}`,
  }
}

function emptyForm() {
  return {
    id: null,
    event_id: null,
    event: null,
    title: '',
    summary: '',
    location: '',
    address: '',
    starts_at: '',
    ends_at: '',
    image_url: '',
    lots: [emptyLot()],
  }
}

function toDatetimeLocal(value) {
  if (!value) return ''
  const raw = String(value)
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw) && !raw.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(raw)) {
    return raw.substring(0, 16)
  }
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) {
    return raw.replace(' ', 'T').substring(0, 16)
  }
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

function resolveEventId(value) {
  if (value && typeof value === 'object') return value.id || null
  return value || null
}

export default {
  name: 'TicketOffers',
  components: { AutocompleteSelectEvent },
  props: {
    user: Object,
  },
  data() {
    return {
      tab: 'cadastro',
      loadingOffers: false,
      loadingTickets: false,
      saving: false,
      mutatingId: null,
      mutatingCode: null,
      dialogForm: false,
      form: emptyForm(),
      offers: [],
      tickets: [],
      eventOptions: [],
      offerPage: 1,
      offerMaxPage: 1,
      ticketPage: 1,
      ticketMaxPage: 1,
      offerFilters: {
        searchText: null,
        site_status: null,
        itemsPerPage: 25,
      },
      ticketFilters: {
        event_id: null,
        code: null,
        status: null,
        itemsPerPage: 25,
      },
      cadastroHeaders: [
        { title: 'Título', align: 'start', key: 'title', sortable: true },
        { title: 'Status', key: 'site_status', sortable: true },
        { title: 'Lotes', key: 'lots_count', sortable: false },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      publishHeaders: [
        { title: 'Título', align: 'start', key: 'title', sortable: true },
        { title: 'Local', key: 'location', sortable: true },
        { title: 'Início', key: 'starts_at', sortable: true },
        { title: 'Lotes', key: 'lots_count', sortable: false },
        { title: 'Status', key: 'site_status', sortable: true },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      ticketHeaders: [
        { title: 'Código', align: 'start', key: 'code', sortable: true },
        { title: 'Evento', key: 'event_title', sortable: false },
        { title: 'Status', key: 'status', sortable: true },
        { title: 'Venda', key: 'sale_id', sortable: true },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      ticketStatusItems: [
        { title: 'Todos', value: null },
        { title: 'Válido', value: 'valid' },
        { title: 'Utilizado', value: 'used' },
        { title: 'Anulado', value: 'voided' },
      ],
    }
  },
  computed: {
    groupSelected() {
      return api.storage.isGroupSelected()
    },
    publishStatusItems() {
      return [{ title: 'Todos', value: null }, ...TICKET_OFFER_STATUSES]
    },
    eventFilterItems() {
      const seen = new Set()
      const items = [{ title: 'Todos', value: null }]
      for (const offer of this.eventOptions || []) {
        const id = offer?.event_id
        if (!id || seen.has(id)) continue
        seen.add(id)
        items.push({
          title: offer.title || offer.event_name || `Evento #${id}`,
          value: id,
        })
      }
      return items
    },
  },
  created() {
    if (this.groupSelected) {
      this.fetchOffers(1)
      this.loadEventOptions()
    }
  },
  activated() {
    if (this.groupSelected) {
      if (this.tab === 'emitidos') {
        this.fetchTickets(this.ticketPage)
      } else {
        this.fetchOffers(this.offerPage)
      }
    }
  },
  methods: {
    siteStatusLabel(value) {
      const found = TICKET_OFFER_STATUSES.find((s) => s.value === value)
      return found ? found.title : value || '—'
    },
    ticketStatusLabel(value) {
      return TICKET_STATUS_LABELS[value] || value || '—'
    },
    lotsCount(item) {
      return Array.isArray(item?.lots) ? item.lots.length : 0
    },
    ticketEventTitle(item) {
      return item?.event_name || item?.title || item?.product_name || '—'
    },
    formatDateTime(value) {
      if (!value) return '—'
      if (this.$moment) {
        return this.$moment(value).format('DD/MM/YYYY HH:mm')
      }
      try {
        return new Date(value).toLocaleString('pt-BR')
      } catch {
        return value
      }
    },
    notifyError(err) {
      const text = err?.response?.data?.message || err?.message
      if (text) {
        this.$notify({ type: 'warn', text })
      }
    },
    offerListPayload() {
      const payload = {
        itemsPerPage: this.offerFilters.itemsPerPage,
      }
      if (this.offerFilters.searchText && this.tab === 'cadastro') {
        payload.searchText = this.offerFilters.searchText
      }
      if (this.tab === 'publicacao' && this.offerFilters.site_status) {
        payload.site_status = this.offerFilters.site_status
      }
      return payload
    },
    applyOfferResult(result) {
      const { items, meta } = normalizeListPayload(result)
      this.offers = items || []
      if (meta) {
        this.offerPage = meta.current_page || this.offerPage
        this.offerMaxPage = meta.last_page || 1
      } else {
        this.offerMaxPage = 1
      }
      this.mergeEventOptions(this.offers)
    },
    mergeEventOptions(rows) {
      const byEvent = new Map()
      for (const existing of this.eventOptions || []) {
        if (existing?.event_id) byEvent.set(existing.event_id, existing)
      }
      for (const row of rows || []) {
        if (row?.event_id) byEvent.set(row.event_id, row)
      }
      this.eventOptions = Array.from(byEvent.values())
    },
    fetchOffers(page) {
      if (!this.groupSelected || this.loadingOffers) return
      const nextPage = Number.isFinite(page) ? page : 1
      this.loadingOffers = true
      this.offerPage = nextPage
      return api.ticketOffer
        .list(this.offerListPayload(), this.offerPage)
        .then((result) => {
          this.applyOfferResult(result)
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.loadingOffers = false
        })
    },
    loadEventOptions() {
      if (!this.groupSelected) return
      return api.ticketOffer
        .list({ itemsPerPage: 200 }, 1)
        .then((result) => {
          const { items } = normalizeListPayload(result)
          this.mergeEventOptions(items)
        })
        .catch(() => {})
    },
    submitOfferSearch() {
      this.fetchOffers(1)
    },
    clearOfferFilters() {
      this.offerFilters.searchText = null
      this.offerFilters.site_status = null
    },
    ticketListPayload() {
      const payload = {
        itemsPerPage: this.ticketFilters.itemsPerPage,
      }
      if (this.ticketFilters.code) payload.code = String(this.ticketFilters.code).trim()
      if (this.ticketFilters.status) payload.status = this.ticketFilters.status
      if (this.ticketFilters.event_id) payload.event_id = Number(this.ticketFilters.event_id)
      return payload
    },
    fetchTickets(page) {
      if (!this.groupSelected || this.loadingTickets) return
      const nextPage = Number.isFinite(page) ? page : 1
      this.loadingTickets = true
      this.ticketPage = nextPage
      return api.ticket
        .list(this.ticketListPayload(), this.ticketPage)
        .then((result) => {
          const { items, meta } = normalizeListPayload(result)
          this.tickets = items || []
          if (meta) {
            this.ticketPage = meta.current_page || this.ticketPage
            this.ticketMaxPage = meta.last_page || 1
          } else {
            this.ticketMaxPage = 1
          }
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.loadingTickets = false
        })
    },
    submitTicketSearch() {
      this.fetchTickets(1)
    },
    clearTicketFilters() {
      this.ticketFilters.event_id = null
      this.ticketFilters.code = null
      this.ticketFilters.status = null
    },
    formFromOffer(item) {
      const lots = (item?.lots || []).map((lot) => ({
        product_id: lot.product_id,
        name: lot.name || '',
        price: lot.price ?? lot.base_price ?? 0,
        available_qty: lot.available_qty ?? 0,
        max_per_order: lot.max_per_order ?? lot.ticket_meta?.max_per_order ?? 10,
        max_scans: lot.max_scans ?? lot.ticket_meta?.max_scans ?? 1,
      }))
      const event = eventFromOffer(item)
      return {
        id: item?.id || null,
        event_id: event?.id || item?.event_id || null,
        event,
        title: item?.title || '',
        summary: item?.summary || '',
        location: item?.location || '',
        address: item?.address || '',
        starts_at: toDatetimeLocal(item?.starts_at),
        ends_at: toDatetimeLocal(item?.ends_at),
        image_url: item?.image_url || '',
        lots: lots.length ? lots : [emptyLot()],
      }
    },
    openCreate() {
      this.form = emptyForm()
      this.dialogForm = true
    },
    editObject(item) {
      if (!item?.id) return
      this.form = this.formFromOffer(item)
      this.dialogForm = true
    },
    closeDialog() {
      this.dialogForm = false
      this.form = emptyForm()
    },
    addLot() {
      if (!Array.isArray(this.form.lots)) this.form.lots = []
      this.form.lots.push(emptyLot())
    },
    removeLot(index) {
      if (!Array.isArray(this.form.lots)) return
      const ix = Number(index)
      if (!Number.isFinite(ix)) return
      this.form.lots.splice(ix, 1)
      if (!this.form.lots.length) this.form.lots.push(emptyLot())
    },
    submitForm() {
      if (this.saving) return
      this.form.event_id = resolveEventId(this.form.event) || this.form.event_id
      const eventId = this.form.event_id
      const lots = (this.form.lots || []).filter((l) => l?.name)
      if (!this.form.title || lots.length < 1) {
        this.$notify({ type: 'warn', text: 'Informe o título e ao menos um lote' })
        return
      }
      if (!eventId) {
        this.$notify({ type: 'warn', text: 'Selecione o evento' })
        return
      }
      const payload = {
        event_id: eventId,
        title: this.form.title,
        summary: this.form.summary,
        location: this.form.location,
        address: this.form.address,
        starts_at: this.form.starts_at || null,
        ends_at: this.form.ends_at || null,
        image_url: this.form.image_url,
        lots: lots.map((l) => ({
          product_id: l.product_id,
          name: l.name,
          price: Number(l.price) || 0,
          available_qty: Number(l.available_qty) || 0,
          max_per_order: Number(l.max_per_order) || 10,
          max_scans: Number(l.max_scans) || 1,
        })),
      }
      if (this.form.id) payload.id = this.form.id
      this.saving = true
      return api.ticketOffer
        .updateOrCreate(payload)
        .then((result) => {
          if (result?.id) {
            const ix = this.offers.findIndex((x) => x.id === result.id)
            if (ix >= 0) {
              this.offers.splice(ix, 1, { ...this.offers[ix], ...result })
            } else {
              this.offers.unshift(result)
            }
            this.mergeEventOptions([result])
          }
          this.$notify({ type: 'success', text: 'Oferta salva' })
          this.closeDialog()
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.saving = false
        })
    },
    pushOffer(item) {
      const id = item?.id
      if (!id || this.mutatingId) return
      this.mutatingId = id
      return api.ticketOffer
        .push(id)
        .then((result) => {
          const offer = result?.offer || result
          if (offer?.id) {
            const ix = this.offers.findIndex((x) => x.id === offer.id)
            if (ix >= 0) {
              this.offers.splice(ix, 1, { ...this.offers[ix], ...offer })
            }
          }
          this.$notify({ type: 'success', text: 'Enviado ao site' })
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.mutatingId = null
        })
    },
    setOfferStatus(item, siteStatus) {
      const id = item?.id
      if (!id || this.mutatingId) return
      this.mutatingId = id
      return api.ticketOffer
        .setStatus(id, siteStatus)
        .then((result) => {
          if (result?.id) {
            const ix = this.offers.findIndex((x) => x.id === result.id)
            if (ix >= 0) {
              this.offers.splice(ix, 1, { ...this.offers[ix], ...result })
            }
          }
          this.$notify({ type: 'success', text: 'Status atualizado' })
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.mutatingId = null
        })
    },
    checkIn(item) {
      const code = item?.code
      if (!code || this.mutatingCode) return
      this.mutatingCode = code
      return api.ticket
        .validate(code)
        .then(() => {
          this.$notify({ type: 'success', text: 'Check-in realizado' })
          return this.fetchTickets(this.ticketPage)
        })
        .catch((err) => {
          this.notifyError(err)
        })
        .finally(() => {
          this.mutatingCode = null
        })
    },
  },
  watch: {
    'form.event'(val) {
      this.form.event_id = resolveEventId(val)
    },
    tab(newVal) {
      if (!this.groupSelected) return
      if (newVal === 'emitidos') {
        this.loadEventOptions()
        this.fetchTickets(1)
      } else {
        this.fetchOffers(1)
      }
    },
    offerPage(newVal, oldVal) {
      if (newVal !== oldVal && !this.loadingOffers && this.groupSelected && this.tab !== 'emitidos') {
        this.fetchOffers(newVal)
      }
    },
    ticketPage(newVal, oldVal) {
      if (newVal !== oldVal && !this.loadingTickets && this.groupSelected && this.tab === 'emitidos') {
        this.fetchTickets(newVal)
      }
    },
  },
}
</script>
